import React from 'react';
import { Link, useLocation } from "react-router-dom";

export const LinkWithQuery = ({to, children, ...props}: {to: string, children: any, [key: string]: any}) => {
    const re = /([^?&]+)=([^?&]+)/g;
    const matches = to.match(re);

    const { search } = useLocation();
    const searchParams = new URLSearchParams(search);
    matches.forEach((match) => {
        searchParams.set(match.split('=')[0], match.split('=')[1]);
    });

    const ms = to.match(/(^\/?.*?)\?(.*)/i);

    const newTo = ms[1] + '?' + searchParams.toString();
    return (
        <Link to={newTo} {...props}>
            {children}
        </Link>
    );
};